import { forEach } from 'lodash';

const install = (app, { utils }) => {
    forEach(utils, (value, key) => {
        app.config.globalProperties[`$${key}`] = value;
    });
};

export default {
    install,
};
